function mergeDateAmount(dataArray) {
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;
    const todayDate = today.getDate();
    const resultMap = new Map();
  
    dataArray.forEach(item => {
      const [month, date] = item.date.split('-');
      const key = (parseInt(month) === todayMonth && parseInt(date) === todayDate && parseInt(item.year) === todayYear) 
        ? '今日' 
        : item.date;
      if (resultMap.has(key)) {
        resultMap.set(key, {
          date: key,
          amount: resultMap.get(key).amount + item.amount
        });
      } else {
        resultMap.set(key, {
          date: key,
          amount: item.amount
        });
      }
    });
  
    return Array.from(resultMap.values())
      .sort((a, b) => b.amount - a.amount);
  }
  
  export default mergeDateAmount;